// @ts-ignore
export default () => (process.env.NODE_ENV === 'development' ? require('apollo-link-logger').default : null);
